module.exports = __webpack_public_path__ + "img/out_of_bounds_right.9b1dce92.jpg";